'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = waitForAssets;

var _waitForStylesheet = require('./waitForStylesheet.js');

var _waitForStylesheet2 = _interopRequireDefault(_waitForStylesheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function waitForAssets(elements) {
  var timeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return elements.filter(function (el) {
    return el.matches('link[rel=stylesheet][href]');
  }).map(function (el) {
    return (0, _waitForStylesheet2.default)(el, timeoutMs);
  });
};